import { render, staticRenderFns } from "./IconSearch.vue?vue&type=template&id=ac58a81e&"
var script = {}
import style0 from "./IconSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac58a81e')) {
      api.createRecord('ac58a81e', component.options)
    } else {
      api.reload('ac58a81e', component.options)
    }
    module.hot.accept("./IconSearch.vue?vue&type=template&id=ac58a81e&", function () {
      api.rerender('ac58a81e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/IconSearch.vue"
export default component.exports